export const REACT_APP_CHECK_API_ENDPOINT =
    process.env.REACT_APP_CHECK_API_ENDPOINT || window.env?.REACT_APP_CHECK_API_ENDPOINT || 'https://areyouwithus-api.ext.syseng-dev.aws.vorboss.net/check';

export const REACT_APP_SPEEDTEST_ENDPOINT =
    process.env.REACT_APP_SPEEDTEST_ENDPOINT || window.env?.REACT_APP_SPEEDTEST_ENDPOINT || 'https://librespeed-speedtest-backend.ext.syseng-prod.aws.vorboss.net';
